import React from 'react'
import PropTypes from 'prop-types'

// Heroicons mini chevron-down (Figma 1704:1334). Sizes with 1em, inherits currentColor.
const PATH_D = 'M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 '
  + '4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z'

const ChevronDownIcon = ({ className }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 20 20"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clipRule="evenodd" d={PATH_D} fillRule="evenodd" />
  </svg>
)

ChevronDownIcon.propTypes = {
  className: PropTypes.string
}

ChevronDownIcon.defaultProps = {
  className: ''
}

export default ChevronDownIcon
